import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { tariff_configs } from 'console/sim/shared/tariff-config';
import { IconButton, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { TariffAmountLabel, } from 'console/sim/billed-sim/details/tariff-amount-label';
import { noop } from 'ts-essentials';
export function TariffAmount(props) {
    const { tariff, sim_status, onHintClick, show_hint } = props;
    const getColor = useCallback((key) => {
        if (!sim_status || !tariff) {
            return undefined;
        }
        const tariff_amount = tariff[key];
        if (tariff_amount < 0) {
            return undefined;
        }
        return sim_status.usage_counters[key] >= tariff_amount
            ? 'warning'
            : undefined;
    }, [sim_status, tariff]);
    const _onHintClick = useCallback((hint) => (e) => onHintClick != null ? onHintClick(hint, e) : noop, [onHintClick]);
    return (_jsx(_Fragment, { children: tariff_configs.map((config, i) => (_jsxs(ListItem, { color: getColor(config.key), children: [_jsx(ListItemIcon, { children: config.icon }), _jsx(ListItemText, { primary: config.title, secondary: _jsx(TariffAmountLabel, { config: config, ...props }) }), show_hint && (_jsx(ListItemSecondaryAction, { color: getColor(config.key), children: _jsx(IconButton, { size: "small", onClick: _onHintClick(config.hint), children: _jsx(HelpOutline, { fontSize: "small" }) }) }))] }, i))) }));
}
